if (!customElements.get('age-modal')) {
  customElements.define('age-modal', class AgeModal extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.overlay = document.getElementById('AgeModalOverlay');
      this.ageStateEl = this.querySelector('#ageState');
      this.provinceFromCookie = Cookies.get('_bevmo_state', { domain: '.bevmo.com' });

      // add listener to select change
      this.ageStateEl.addEventListener('change', this.onSelectChange.bind(this));
    }

    async getProvinceCode() {
      const existingCode = this.provinceFromCookie || this.provinceFromGeoIP;

      if (existingCode) { return existingCode; }

      const detail = await bevmoLocation.getGeoIPDetail();
      this.provinceFromGeoIP = detail.province_code;
    
      return this.provinceFromGeoIP;
    }

    async checkLocation() {
      if (!window.location.origin.includes('bevmo.com') || window.isUserCrawler) {
        return;
      }

      const provinceCode = await this.getProvinceCode();
      const expectedStore = bevmoExpectedStoreByState(provinceCode);

      if (!expectedStore) { return; }

      if (window.location.origin === `https://${expectedStore.primary_domain}`) {
        return;
      }

      bevmoLocation.switchStore(expectedStore);
    }
    
    async connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.checkLocation();
    }
  
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
  
    hide() {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }

    async showModal() {
      const provinceCode = await this.getProvinceCode();

      if (provinceCode) {
        // select option element by value
        const valid_option = this.ageStateEl.querySelector(`option[value="${provinceCode}"]`);

        const element = document.getElementById('ageState');
        if (valid_option) {
          element.value = provinceCode;
        } else {
          element.value = 'CA';
        }
        //trigger change event
        const event = new Event('change');
        element.dispatchEvent(event);
      }

      this.overlay.classList.remove('hidden');
      this.show();
    }

    // Change the width of the select box with the width of the option text
    onSelectChange() {
      const index = this.ageStateEl.selectedIndex;
      const text = this.ageStateEl.options[index].text;
      const widthChecker = document.createElement('select');
      widthChecker.innerHTML = `<option>${text}</option>`;
      widthChecker.classList.add(`age-modal__state`);
      this.querySelector('.age-modal__text').insertBefore(widthChecker, this.ageStateEl);
      this.ageStateEl.style.width = `${widthChecker.offsetWidth + 5}px`;
      widthChecker.remove();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      const formData = new FormData(this.form);
      const formDataObject = Object.fromEntries(formData);

      if (!formDataObject.state || formDataObject.state === '') {
        return;
      }

      window.bevmoLocation.setAndCheckDomain(formDataObject.state);

      this.hide();
      this.overlay.classList.add('hidden');
    }
  });
}
